import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IconModule } from "ng-zorro-antd-mobile/icon";
import { ComponentModule } from "@root/component/component.module";
import { SharedModule } from "@root/shared/shared.module";
import { NzCarouselModule } from "ng-zorro-antd/carousel";
import { ModuleSharedComponentModule } from "../component/module-shared-component.module";
import { AccountFormModalComponent } from "./account/account-form-modal/account-form-modal.component";
import { AccountFormModifyPasswordModalComponent } from "./account/account-form-modify-password-modal/account-form-modify-password-modal.component";
// import { AccountComponent } from "./account/account-list/account.component";
import { AgodaLinkComponent } from "./account/agoda-link/agoda-link.component";
import { AirbnbAccountComponent } from "./account/airbnb-account/airbnb-account.component";
// import { AirbnbAuthSuccessComponent } from "./account/airbnb-auth-success/airbnb-auth-success.component";
import { BaseAccountListComponent } from "./account/base-account-list/base-account-list.component";
import { BookingLinkComponent } from "./account/booking-link/booking-link.component";
import { ModalRequestStatusComponent } from "./account/modal-request-status/modal-request-status.component";
import { OnboardingAccountListComponent } from "./account/onboarding-account-list/onboarding-account-list.component";
import { TestQueuingModalComponent } from "./account/test-queuing-modal/test-queuing-modal.component";
import { V4ConnectSuccessComponent } from "./account/v4/connect-success/connect-success.component";
import { V4ConnectWithAgodaComponent } from "./account/v4/connect-with-agoda/connect-with-agoda.component";
import { V4ConnectWithAirbnbComponent } from "./account/v4/connect-with-airbnb/connect-with-airbnb.component";
import { V4ConnectWithBookingComponent } from "./account/v4/connect-with-booking/connect-with-booking.component";
import { V4ConnectWithVrboComponent } from "./account/v4/connect-with-vrbo/connect-with-vrbo.component";
import { VrboLinkComponent } from "./account/vrbo-link/vrbo-link.component";
import { ChannelMenuComponent } from "./account/widget/channel-menu/channel-menu.component";
// import { BookingComponent } from "./booking/booking.component";
// import { ChannelHouseComponent } from "./channel-house/channel-house.component";
import { ChannelComponent } from "./channel.component";
import { BindHousePickerPanelComponent } from "./component/bind-house-picker-panel/bind-house-picker-panel.component";
import { BaseHouseRelationComponent } from "./house-relation/base-house-relation/base-house-relation.component";
import { HouseRelationHouseCardComponent } from "./house-relation/house-relation-house-card/house-relation-house-card.component";
import { HouseRelationLeftPanelComponent } from "./house-relation/house-relation-left-panel/house-relation-left-panel.component";
import { HouseRelationRightPanelComponent } from "./house-relation/house-relation-right-panel/house-relation-right-panel.component";
import { HouseRelationComponent } from "./house-relation/house-relation.component";
import { OnboardingHouseRelationComponent } from "./house-relation/onboarding-house-relation/onboarding-house-relation.component";
import { ConnectFirstAccountComponent } from "./account/widget/connect-first-account/connect-first-account.component";
import { LinkRoomTypeNoteComponent } from "./house-relation/link-room-type-note/link-room-type-note.component";
import { V4ConnectWithXhsComponent } from "./account/v4/connect-with-xhs/connect-with-xhs.component";
import { V4ConnectWithDouyinComponent } from "./account/v4/connect-with-douyin/connect-with-douyin.component";
import { V4ConnectWithCtripComponent } from "./account/v4/connect-with-ctrip/connect-with-ctrip.component";
import { AccountOccupiedWarningComponent } from "./component/account-occupied-warning/account-occupied-warning.component";
import { V4ConnectWithGoogleComponent } from "./account/v4/connect-with-google/connect-with-google.component";
import { V4ConnectWithExpediaComponent } from "@root/router/channel/account/v4/connect-with-expedia/connect-with-expedia.component";
import { V4ConnectWithHoufyComponent } from "./account/v4/connect-with-houfy/connect-with-houfy.component";
import { V4SetPricingRatioComponent } from "./account/v4/set-pricing-ratio/set-pricing-ratio.component";
import { V4ConnectWithTongchengComponent } from "./account/v4/connect-with-tongcheng/connect-with-tongcheng.component";

const Components = [
  ChannelComponent,
  // AccountComponent,
  HouseRelationComponent,
  // ChannelHouseComponent,
  BaseAccountListComponent,
  BaseHouseRelationComponent,
  AccountFormModalComponent,
  AccountFormModifyPasswordModalComponent,
  AirbnbAccountComponent,
  ModalRequestStatusComponent,
  // ChannelHouseComponent,
  // AirbnbAuthSuccessComponent,
  TestQueuingModalComponent,
  BookingLinkComponent,
  AgodaLinkComponent,
  // BookingComponent,
  VrboLinkComponent,
  OnboardingAccountListComponent,
  OnboardingHouseRelationComponent,
  LinkRoomTypeNoteComponent,
  AccountOccupiedWarningComponent,
];
const Widgets = [
  HouseRelationLeftPanelComponent,
  HouseRelationRightPanelComponent,
  HouseRelationHouseCardComponent,
  BindHousePickerPanelComponent,
  ChannelMenuComponent,
  ConnectFirstAccountComponent,
];

const V4Components = [
  V4ConnectWithAirbnbComponent,
  V4ConnectSuccessComponent,
  V4ConnectWithBookingComponent,
  V4ConnectWithVrboComponent,
  V4ConnectWithAgodaComponent,
  V4ConnectWithXhsComponent,
  V4ConnectWithDouyinComponent,
  V4ConnectWithCtripComponent,
  V4ConnectWithGoogleComponent,
  V4ConnectWithExpediaComponent,
  V4ConnectWithHoufyComponent,
  V4SetPricingRatioComponent,
];
const V4StandaloneCmps = [V4ConnectWithTongchengComponent];

const Modules = [
  CommonModule,
  SharedModule,
  ComponentModule,
  ModuleSharedComponentModule,
  IconModule,
  NzCarouselModule,
];

/**
 * 该模块存在意义是抽离组件，而不包含路由模块
 * 由于该模块会被其他模块引用，如果包含路由模块，可能会导致路由冲突，因此这里独立抽离出一个模块，纯粹用于声明组件和将必要的模块导出
 * 由于该module实际属于公共module，因此为了体积优化，这里仅仅声明必须的组件，其他仅在channel模块中使用的组件则由channel.module声明
 * 实际上，该模块与component.module等模块无本质区别，这里只是为了便于管理，放在channel模块下
 */

@NgModule({
  imports: [...Modules, ...V4StandaloneCmps],
  declarations: [...Components, ...Widgets, ...V4Components],
  exports: [...Components, ...Widgets, ...V4Components, ...Modules],
})
export class ChannelSharedComponentsModule {}
